
import React, { useEffect } from "react";
import Header from "@/components/Header";
import Hero2 from "@/components/Hero2";
import Features2 from "@/components/Features2";
import PricingPlans from "@/components/PricingPlans";
import Benefits2 from "@/components/Benefits2";
import TargetAudience from "@/components/TargetAudience";
import TestOurAI from "@/components/TestOurAI";
import AIGallery from "@/components/AIGallery";
import CTA2 from "@/components/CTA2";
import Footer from "@/components/Footer";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import { isBrowser } from "@/utils/runtime";

const Home2 = () => {
  // Set page title for SEO
  useEffect(() => {
    if (!isBrowser) return;
    globalThis.document.title = "Toc Rápido | Edição Automática de Fotos para Imóveis | Toc Toc IA";
    // Add meta description dynamically
    const metaDescription = globalThis.document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content",
        "Toc Rápido: Transforme suas fotos de imóveis com IA em segundos. Edição profissional automatizada para corretores que querem vender mais rápido. Experimente grátis!");
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main>
        {/* Main hero section with primary keywords */}
        <section id="inicio" aria-label="Página inicial do Toc Rápido">
          <Hero2 />
        </section>
        
        {/* Features section with semantic HTML */}
        <section id="recursos" aria-label="Recursos do Toc Rápido">
          <Features2 />
        </section>
        
        {/* Gallery section */}
        <section id="galeria" aria-label="Exemplos de fotos editadas com Toc Rápido">
          <AIGallery />
        </section>
        
        {/* Test our AI section */}
        <section id="teste-gratis" aria-label="Experimente o Toc Rápido gratuitamente">
          <TestOurAI />
        </section>
        
        {/* Pricing plans with schema markup */}
        <section id="planos" aria-label="Planos de assinatura do Toc Rápido">
          <PricingPlans />
        </section>
        
        {/* Benefits section */}
        <section id="beneficios" aria-label="Benefícios do Toc Rápido">
          <Benefits2 />
        </section>
        
        {/* Target audience section */}
        <section id="para-quem" aria-label="Para quem o Toc Rápido é indicado">
          <TargetAudience />
        </section>
        
        {/* Call to action section */}
        <section id="cta" aria-label="Comece a usar o Toc Rápido agora">
          <CTA2 />
        </section>
      </main>
      <Footer />
      <ExitIntentPopup />
    </div>
  );
};

export default Home2;
